// Get all elements with the class "navbar-item dropdown"
const dropdownItems = document.querySelectorAll('.navbar-item.dropdown a');

// Get the pseudo-element
const pseudoElement = document.querySelector('.navspacer');

// Add a click event listener to each dropdown item
dropdownItems.forEach(item => {
	item.addEventListener('click', () => {
		// Increase the left position by 100px
		const liLeft = item.offsetLeft;
		const liWidth = item.offsetWidth;
		// Set the left position and width for the pseudo-element
		pseudoElement.style.left = `${liLeft}px`;
		pseudoElement.style.width = `${liWidth}px`;
	});
});
